import { render } from "./ScaleTareItem.vue?vue&type=template&id=7bc4720c&ts=true"
import script from "./ScaleTareItem.vue?vue&type=script&lang=ts"
export * from "./ScaleTareItem.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__